import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clickExplanationIconTrigger from '@coolblue-development/ga4-events/triggers/InsuranceSelector/clickExplanationIconTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ExplanationIcon } from '@coolblue-development/next-patterns/client';
import { useState } from 'react';
import { InsuranceProvider } from '../types.js';
import InsuranceDetailsModal from './InsuranceDetailsModal.js';
export function InsuranceExplanationIcon({ insuranceProductId, insuranceQuoteId, productId, title, modalAction, trackingSubFeature, provider, }) {
    const [open, setOpen] = useState(false);
    const { trackEvent } = useAnalytics();
    function handleExplanationLinkClick() {
        setOpen(true);
        if (!trackingSubFeature)
            return;
        trackEvent(clickExplanationIconTrigger({
            sub_feature: trackingSubFeature,
            subject_id: provider === InsuranceProvider.ERGO ? insuranceProductId : insuranceQuoteId || '',
        }));
    }
    function getInsuranceId() {
        switch (provider) {
            case InsuranceProvider.ERGO:
                return insuranceProductId;
            default:
                return insuranceQuoteId;
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx(ExplanationIcon, { testId: "insurance-explanation-icon", onClick: handleExplanationLinkClick }), _jsx(InsuranceDetailsModal, { open: open, onClose: () => setOpen(false), insuranceId: getInsuranceId(), productId: productId, provider: provider, title: title, action: modalAction })] }));
}
export default InsuranceExplanationIcon;
//# sourceMappingURL=InsuranceExplanationIcon.js.map